
import React from "react";
import { Container, Row, Col, Navbar } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import 'bootstrap-icons/font/bootstrap-icons.css';
import "./footer.css";
import logo from "../../../assets/images/logo.png";


const Footer = () => {
  return (
    <footer className="footer-section">
      <Container>
        <Row>
          <Col md="4" sm="12" className="mb-4">
            <img
              src={logo}
              alt="Logo"
              style={{
                height: "100px",
                objectFit: "contain",
                marginTop: "-12px",
              }}
            />

            <p className="footer-text">
              Trusted by 1000+ travelers. 24/7 Support | Verified Itineraries | Secure Bookings
            </p>
            <div className="social-icons mt-3">
              <a href="https://www.facebook.com/shivaytourandtravells" target="_blank" rel="noreferrer" className="me-3">
                <i className="bi bi-facebook"></i>
              </a>
              <a href="https://www.instagram.com/shivaay_tour_travells" target="_blank" rel="noreferrer" className="me-3 social-icon">
                <i className="bi bi-instagram"></i>
              </a>
              <a href="https://wa.me/917600668600?text=Hello%20Shivay%20Tour%20and%20Travels" target="_blank" rel="noreferrer">
                <i className="bi bi-whatsapp"></i>
              </a>
            </div>
          </Col>

          <Col md="2" sm="6" className="mb-4">
            <h4 className="mt-lg-0 mt-sm-3">Quick Links</h4>
            <ul className="list-unstyled">
              <li><NavLink to="/">Home</NavLink></li>
              <li><NavLink to="/about-us">About</NavLink></li>
              <li><NavLink to="/tours">Tours</NavLink></li>
              <li><NavLink to="/gallery">Gallery</NavLink></li>
              <li><NavLink to="/contact-us">Contact</NavLink></li>
            </ul>
          </Col>
          <Col md="3" sm="6" className="mb-4">
            <h4 className="mt-lg-0 mt-sm-3">Legal</h4>
            <ul className="list-unstyled">
              <li><NavLink to="/privacy-policy">Privacy Policy</NavLink></li>
              <li><NavLink to="/terms-and-conditions">Terms & Conditions</NavLink></li>
              <li><NavLink to="/disclaimer">Disclaimer</NavLink></li>
            </ul>
          </Col>
          <Col md="3" sm="12" className="location mt-3 mt-md-0">
            <h4 className="mt-lg-0 mt-sm-3">Contact Info</h4>

            <div className="d-flex align-items-start mb-2">
              <i className="bi bi-geo-alt me-3"></i>
              <a
                href="https://maps.app.goo.gl/tvS9EYMmv9LJYGC5A"
                target="_blank"
                rel="noreferrer"
                className="text-break"
              >
                Riddhi Apartment, 6, near Kiran Chowk, Punagam to Yogi Chowk Road, Surat, Gujarat 395010
              </a>
            </div>

            <div className="d-flex align-items-start my-2">
              <i className="bi bi-envelope me-3"></i>
              <a href="mailto:shivaytourandtravells@gmail.com" className="text-break">
                shivaytourandtravells@gmail.com
              </a>
            </div>

            <div className="d-flex align-items-start mb-1">
              <i className="bi bi-telephone me-3"></i>
              <a href="tel:7600668600">7600668600</a>
            </div>

            <div className="d-flex align-items-start">
              <i className="bi bi-telephone me-3"></i>
              <a href="tel:9173005554">9173005554</a>
            </div>
          </Col>
        </Row>

        <hr />
        <p className="text-center mb-0">
          &copy; {new Date().getFullYear()} Shivay Tour & Travels. All rights reserved.
        </p>
      </Container>
    </footer>
  );
};

export default Footer;


